import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { LABEL_NAME_MAX_LENGTH } from 'const/limits'
import { SubmissionError } from 'redux-form'
import {
  Button,
  ButtonGroup
} from 'react-bootstrap'
import {
  BoardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import LabelForm from '../LabelForm'

export class EditLabel extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.number.isRequired,

    requestChangeLabelName: PropTypes.func.isRequired,
    requestChangeLabelColor: PropTypes.func.isRequired
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ name, color }) => {
    const { cancelForm } = this
    const {
      intl,
      id,
      name: currentName,
      color: currentColor,
      requestChangeLabelName,
      requestChangeLabelColor
    } = this.props

    return new Promise((resolve) => {
      if (!name) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'LABEL_EMPTY' })
        })
      } else if (name.length > LABEL_NAME_MAX_LENGTH) {
        throw new SubmissionError({
          name: intl.formatMessage(
            { id: 'LABEL_TOO_LONG' },
            { limit: LABEL_NAME_MAX_LENGTH }
          )
        })
      }

      if (name !== currentName) {
        requestChangeLabelName({
          id,
          name
        })
      }

      if (color !== currentColor) {
        requestChangeLabelColor({
          id,
          color
        })
      }

      resolve()

      cancelForm()
    })
  }

  render () {
    const {
      id,
      name,
      color
    } = this.props

    return (
      <BoardModalView
        title={name}
      >
        <ViewBody>
          <LabelForm
            form={'editLabel-' + id}
            onSubmit={this.handleFormSubmit}
            initialValues={{
              name,
              color
            }}
            actions={({ submitting }) =>
              <ButtonGroup>
                <Button type='submit' bsStyle='primary' disabled={submitting}><FormattedMessage id='SAVE' /></Button>
                <Button onClick={this.cancelForm} disabled={submitting}><FormattedMessage id='CANCEL' /></Button>
              </ButtonGroup>
            }
          />
        </ViewBody>
      </BoardModalView>
    )
  }
}

export default injectIntl(withLeftSidebar(EditLabel))
